module.exports = __webpack_public_path__ + "img/swaddle_muslin.0db8082b.jpg";